import { isLocationPageType } from '../../domain/useCases/pageTypeCheck'

const MINIMUM_CENTERS_FOR_SPOTLIGHT_BLOCK = 3
export const shouldRenderSpotlightBlock = ({ pageType, reviewCount }) => {
  return (
    isLocationPageType(pageType) &&
    reviewCount > MINIMUM_CENTERS_FOR_SPOTLIGHT_BLOCK
  )
}
